module.exports = __webpack_public_path__ + "img/submitExam.a2a26d9f.png";